import createHocName from '@wix/communities-forum-client-commons/dist/src/services/create-hoc-name';

const withHocName = name => Component => {
  Component.displayName = createHocName(name, Component);
  return Component;
};

export default withHocName;
